import { innerSearch } from 'api/Api';
import LoadingIndicator from 'app/components/LoadingIndicator';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

interface ReturnForm {
  resultStatus: string;
  resultMessage: string;
  resultCode: string;
  tid: string;
  orderId: string;
  mallReserved: string;
  schemeGroup: string;
  schemeCode: string;
  approvalNo?: string;
}

const UIIframePage: React.FC = () => {
  const { t } = useTranslation();
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const { setPaymentState } = usePaymentState();
  const [resultForm, setResultForm] = useState<ReturnForm>();

  const [tid, setTid] = useState<string>('');
  const [approvalNo, setApprovalNo] = useState<string>('');
  const [returnUrl, setReturnUrl] = useState<string>('');
  const [iframeUrl, setIframeUrl] = useState<string>('');

  useEffect(() => {
    const paramTid = new URLSearchParams(searchParams).get('tid');
    const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');
    const approvalNo = new URLSearchParams(searchParams).get('approvalNo');

    if (approvalNo) {
      setApprovalNo(approvalNo);
    }
    if (paramTid) {
      setTid(paramTid);
      setPaymentState(prevState => ({
        ...prevState,
        tid: paramTid,
      }));
    }
    if (paramPayUrl) {
      setIframeUrl(paramPayUrl);
    }
  }, [searchParams]);

  useEffect(() => {
    if (resultForm && returnUrl) {
      const url = new URL(returnUrl);
      const params = new URLSearchParams(url.search);

      params.set('resultStatus', 'PENDING');
      params.set('resultCode', resultForm.resultCode);
      params.set('resultMessage', resultForm.resultMessage);
      params.set('tid', resultForm.tid);
      params.set('orderId', resultForm.orderId);
      params.set('mallReserved', resultForm.mallReserved);
      params.set('schemeGroup', resultForm.schemeGroup);
      params.set('schemeCode', resultForm.schemeCode);
      if (approvalNo) {
        params.set('approvalNo', approvalNo);
      }
      if (iframeUrl) {
        params.set('paymentUrl', iframeUrl);
      }
      window.location.href = url + '?' + params;
    }
  }, [resultForm, returnUrl]);

  //InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      //ReturnUrl Set
      setReturnUrl(data.data.returnUrl);
      //ResultForm Set
      setResultForm({
        resultStatus: data.data.response.resultStatus,
        resultMessage: data.data.response.resultMessage,
        resultCode: data.data.response.resultCode,
        tid: data.data.response.tid,
        orderId: data.data.response.orderId,
        mallReserved: data.data.response.mallReserved,
        approvalNo: approvalNo,
        schemeGroup: data.data.response.schemeGroup,
        schemeCode: data.data.response.schemeCode,
      });
      // Status 예외처리
      if (
        data.data.response.resultStatus === null ||
        data.data.response.resultStatus === undefined
      ) {
        navigate('/error');
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const handlePopupClose = e => {
    e.preventDefault();
    transactResult.mutate();
  };

  useEffect(() => {
    if (approvalNo) {
      const parentOrigin = window.location.origin;
      const data = { approvalNo: approvalNo, payUrl: iframeUrl };
      if (window.opener) {
        window.opener.postMessage(data, parentOrigin);
      }
    }
  }, [approvalNo, iframeUrl]);

  return (
    <>
      <div className="payverse-wrap">
        <div className="payverse">
          {iframeUrl ? (
            <>
              <iframe
                id="payment-iframe"
                src={iframeUrl}
                width="100%"
                height={isMobile ? '90%' : '100%'}
              ></iframe>
              {isMobile && (
                <div
                  className="c-section"
                  style={{
                    height: '5%',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <div
                    className="box"
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      marginLeft: '0',
                      alignItems: 'center',
                    }}
                  >
                    <button className="orange" onClick={handlePopupClose}>
                      {t('payment_confirm')}
                    </button>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <div style={{ width: '100%', height: '140px' }}></div>
              <LoadingIndicator />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default UIIframePage;
